import { Injectable } from '@angular/core';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { take } from 'rxjs/operators';

@Injectable()
export class OneClickSetDeliveryInstructionCommand implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: string): void {
    if (value !== null && value !== undefined) {
      this.store
        .select(getOneClickSelectedOrder)
        .pipe(take(1))
        .subscribe(order => {
          const modded: Order = {
            ...order,
            instructions: value,
          };

          this.store.dispatch(new OneClickUpdateOrderAction(modded));
        });
    }
  }
}
